import * as React from 'react';

import {theme} from '../../constants';

type Props = {
  bgColor?: string;
  iconColor?: string;
  onClick?: () => void;
};

export const ProfileTabSvg: React.FC<Props> = ({
  onClick,
  bgColor = `${theme.colors.black}20`,
  iconColor = theme.colors.pastelMint,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={50}
      height={50}
      fill='none'
      onClick={onClick}
    >
      <circle cx={25} cy={25} r={25} fill={bgColor} />
      <g>
        <path
          fill={iconColor}
          d='M33.485 16.515A11.921 11.921 0 0 0 25 13a11.921 11.921 0 0 0-8.485 3.515A11.921 11.921 0 0 0 13 25c0 3.205 1.248 6.219 3.515 8.485A11.921 11.921 0 0 0 25 37c3.205 0 6.219-1.248 8.485-3.515A11.921 11.921 0 0 0 37 25c0-3.205-1.248-6.219-3.515-8.485Zm-14.47 17.222A6.059 6.059 0 0 1 25 28.716a6.059 6.059 0 0 1 5.984 5.02A10.534 10.534 0 0 1 25 35.595c-2.219 0-4.28-.687-5.984-1.857Zm2.17-10.243A3.82 3.82 0 0 1 25 19.678a3.82 3.82 0 0 1 3.816 3.816A3.82 3.82 0 0 1 25 27.309a3.82 3.82 0 0 1-3.816-3.815Zm11.017 9.267a7.474 7.474 0 0 0-2.184-3.519 7.476 7.476 0 0 0-2.173-1.372 5.221 5.221 0 0 0 2.377-4.376A5.228 5.228 0 0 0 25 18.272a5.228 5.228 0 0 0-5.222 5.222c0 1.83.947 3.444 2.377 4.376a7.478 7.478 0 0 0-2.173 1.372 7.476 7.476 0 0 0-2.184 3.52A10.567 10.567 0 0 1 14.406 25c0-5.841 4.753-10.594 10.594-10.594 5.841 0 10.594 4.753 10.594 10.594 0 3.063-1.307 5.826-3.392 7.761Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M13 13h24v24H13z' />
        </clipPath>
      </defs>
    </svg>
  );
};
